
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { DashboardLayout } from "@/components/dashboard/DashboardLayout";
import { useDashboard } from "@/hooks/use-dashboard";
import { AgentRuntimeLoader } from "@/components/agent-run/AgentRuntimeLoader";
import { AgentRuntimeError } from "@/components/agent-run/AgentRuntimeError";
import { AgentRuntimeContent } from "@/components/agent-run/AgentRuntimeContent";
import { useAgentRuntime } from "@/hooks/use-agent-runtime";

export default function AgentRuntime() {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const { activeTab, setActiveTab, walletData, loadingWallet } = useDashboard();
  const { 
    user, 
    loading, 
    agent, 
    agentSchema, 
    result, 
    setResult, 
    executionHistory 
  } = useAgentRuntime(id);

  // Redirect if user is not logged in
  React.useEffect(() => {
    if (!loading && !user) {
      navigate("/login");
    }
  }, [user, loading, navigate]);

  if (loading) {
    return <AgentRuntimeLoader />;
  }

  if (!user) {
    return null;
  }

  if (!agent) {
    return <AgentRuntimeError />;
  }

  const formattedWalletData = {
    balance: walletData?.balance ?? 0,
    agentsPurchased: walletData?.agentsPurchased ?? 0,
    lastPurchase: walletData?.lastPurchase ?? 'No purchases yet'
  };

  return (
    <DashboardLayout 
      user={user}
      isLoading={loading}
      activeTab={activeTab}
      setActiveTab={setActiveTab}
      walletData={formattedWalletData}
      loadingWallet={loadingWallet}
    >
      {agent && agentSchema && (
        <AgentRuntimeContent
          agent={agent}
          agentRuntimeDef={agentSchema}
          setResult={setResult}
          result={result}
          executionHistory={executionHistory}
          onBack={() => navigate(-1)}
        />
      )}
    </DashboardLayout>
  );
}
